<template>
  <div style="position: absolute; width: 803px; top: 0px; right: 0px;">
    <transition name="fade" tag="div">
      <div v-for="i in [currentIndex]" :key="i">
        <v-img lazy :src="currentImg" />
      </div>
    </transition>
    <a @click="nextslide()">next</a>
  </div>
</template>

<script>
export default {
  data: () => ({
    // images: ['././img/hw_maler.webp', '././img/hwfoto221.webp', '././img/hwfoto221_rot.webp'],
    images: ['././img/hw_maler.webp', '././img/hwfoto221.webp'],
    key: 0,
    timer: null,
    currentIndex: 0,
    item: ''
  }),
  created () {},
  beforeDestroy () {
    clearInterval(this.timer)
  },
  computed: {
    currentImg: function () {
      return this.images[Math.abs(this.currentIndex) % this.images.length]
    }
  },
  components: {},
  mounted () {
    this.startSlider()
  },
  methods: {
    startSlider: function () {
      this.timer = setInterval(() => {
        this.nextslide()
      }, 8000)
    },
    nextslide: function () {
      this.currentIndex += 1
    }
  }
}
</script>

<style>
.vollehoehe {
  height: 100% !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 3s ease;
  overflow: hidden;
  visibility: visible;
  position: absolute;
  width: 100%;
  opacity: 1;
}

.fade-enter,
.fade-leave-to {
  visibility: hidden;
  width: 100%;
  opacity: 0;
}
</style>
